import { render, staticRenderFns } from "./warehouseconsumabletype.vue?vue&type=template&id=62ff8f64&scoped=true&"
import script from "./warehouseconsumabletype.vue?vue&type=script&lang=js&"
export * from "./warehouseconsumabletype.vue?vue&type=script&lang=js&"
import style0 from "./warehouseconsumabletype.vue?vue&type=style&index=0&id=62ff8f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff8f64",
  null
  
)

export default component.exports